export default function HealthcheckRoute() {
  return (
    <main className="container">
      <h1>Healthcheck</h1>
    </main>
  )
}
